import { Button, Group, Modal, Select, Stack, TextInput } from "@mantine/core";
import { IconKey } from "@tabler/icons-react";
import { useState } from "react";
import { createAIKey } from "../../../../../api/ConfigsApi";
import { notifications } from "@mantine/notifications";
import { useLanguage } from "../../../../../stores/LanguageStore";
import BackButton from "../../../../../components/View/BackButton";
import { useProfileStore } from "../../../../../stores/UserStore";

const AddExternalKey = ({ onFinish, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [type, setType] = useState("openai");

  const [opened, setOpened] = useState(false);
  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    setError(null);
    createAIKey({
      ...data,
      name: data?.name,
      api_key: data?.api_key,
      type: type,
    })
      .then((response) => {
        onFinish?.();
        handleClose()
        notifications.show({
          message: lang.integrations.row_highlight.created,
          color: "tertiary.8",
        });
      })
      .catch((err) => {
        let message = err.response?.data?.state_message;
        setLoading(false);
        if (message === "invalid_api_key") {
          setError("api_key");
          return document.getElementById("api_key-field").focus();
        }
      });
  };

  return (
    <>
      <Button
        size="md"
        leftSection={<IconKey />}
        onClick={handleOpen}
        {...props}
      >
        {lang.settings.add_int}
      </Button>

      <Modal
        title={lang.integrations.create.dialog.title}
        opened={opened}
        onClose={handleClose}
      >
        <Stack mx={"auto"} component={"form"} onSubmit={handleSubmit}>
          <TextInput
            name="name"
            label={lang.integrations.create.dialog.name}
            placeholder={lang.integrations.create.dialog.name}
            autoFocus
            required
            size="md"
          />

          <Select
            label={lang.api_keys.columns.type}
            name="type"
            defaultValue={"openai"}
            required
            data={[
              {
                label: "OpenAI",
                value: "openai",
              },
              // {
              //   label: "Datagma",
              //   value: "datagma",
              // },
              // {
              //   label: "FullEnrich",
              //   value: "fullenrich",
              // },
              {
                label: "Kaspr",
                value: "kaspr",
              },
              {
                label: "Dropcontact",
                value: "dropcontact",
              },
              {
                label: "ContactOut",
                value: "contactout",
              },
              {
                label: "OVH",
                value: "ovh",
                disabled: useProfileStore.getState().profile?.level !== "admin",
              },
            ]}
            size="md"
            onChange={setType}
            value={type}
          />

          {type === "ovh" ? (
            <>
              <TextInput
                name="api_key"
                label="Clé API"
                placeholder="La clé API donné par OVH"
                size="md"
                required
              />
              <TextInput
                name="api_secret"
                label="Clé secrète"
                placeholder="La clé secrète donné par OVH"
                size="md"
                required
              />
              <TextInput
                name="consumer_key"
                label="Clé du consommateur (consumer key)"
                placeholder="La clé du consommateur donné par OVH"
                size="md"
                required
              />
            </>
          ) : (
            <TextInput
              id="api_key-field"
              name="api_key"
              label={lang.integrations.create.dialog.key}
              placeholder={
                "sk-OpSB4rsdS6xd4v9gsau4T3BlbkBJNvYBJES7WUdn76XWJKZX"
              }
              required
              error={
                error === "api_key" ? lang.errors.main.invalid_api_key : null
              }
              size="md"
            />
          )}

          <Group justify="flex-end" mt={"md"}>
            <BackButton onClick={handleClose} size="md" />
            <Button type="submit" loading={loading} size="md">
              {lang.integrations.create.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default AddExternalKey;
